import { render, staticRenderFns } from "./GetCode.vue?vue&type=template&id=65e0feac&scoped=true&"
import script from "./GetCode.vue?vue&type=script&lang=js&"
export * from "./GetCode.vue?vue&type=script&lang=js&"
import style0 from "./GetCode.vue?vue&type=style&index=0&id=65e0feac&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e0feac",
  null
  
)

export default component.exports